(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["oscanna-glasses-offer"] && !Shopify.designMode) return;
  try {
    (() => {
    const selector = '.oscanna-pack-choice[data-oscanna-price-target]';
    const syncPrice = (choice) => {
      const selected = choice.querySelector('input[name="quantity"]:checked');
      const target = document.getElementById(choice.dataset.oscannaPriceTarget);
      if (!selected || !target) return;
      const price = target.querySelector('.price');
      if (!price) return;
      const amount = price.querySelector(price.classList.contains('price--on-sale')
        ? '.price__sale .price-item--sale'
        : '.price__regular .price-item--regular');
      const total = selected.value === '2' ? choice.dataset.pairPrice : choice.dataset.singlePrice;
      if (amount && total) amount.textContent = total;
    };
    const syncAll = () => document.querySelectorAll(selector).forEach(syncPrice);
    document.addEventListener('change', (event) => {
      if (!(event.target instanceof HTMLInputElement) || event.target.name !== 'quantity') return;
      const choice = event.target.closest(selector);
      if (choice) syncPrice(choice);
    });
    document.addEventListener('shopify:section:load', syncAll);
    window.addEventListener('pageshow', syncAll);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncAll, { once: true });
    else syncAll();
  })();
  } catch(e) { console.error(e); }
})();

})();
